<script setup>
import { computed, onMounted } from 'vue';

  const props = defineProps({
    doc: {
      type: Object,
      default: () => ({})
    },
    full: {
      type: Boolean,
      default: false
    },
    list: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }

  });


const labels = {
  houses: {
    "1": "1 Casa",
    "2-4": "2 a 4 Casas",
    "5-10": "5 a 10 Casas",
    ">10": "Más de 10 Casas",
  },
  markets: {
    "1": "1 Negocio",
    "2-4": "2 a 4 Negocios",
    "5-10": "5 a 10 Negocios",
    ">10": "Más de 10 Negocios",
  },
  vehicleType: {
    "car": "Cualquier Vehiculo",
    "truck": "Vehiculos Altos",
    "4x4": "Solo 4x4",
    "motorcycle": "Solo Motos",
    "bicycle": "Solo Bicicletas",
    "walking": "Solo Caminando",
  },
  security: {
    // tranquilo, normal, inseguro, peligroso, muy peligroso
    "low": "Zona Tranquila",
    "normal": "Precauciones normales",
    "unsafe": "Zona Insegura",
    "dangerous": "Zona Peligrosa",
    "very-dangerous": "Zona Muy Peligrosa",
  }
}

  const data = computed(() => {
    const points = props.doc.points || [];

    // zonas pobladas
    const homes = points.filter(point => point.type === 'home');
    // casa estadisticas
    const homeStats = homes.reduce((acc, home) => {
      acc[home.houses] = acc[home.houses] ? acc[home.houses] + 1 : 1;
      return acc;
    }, {});

    const markets = points.filter(point => point.type === 'market');
    const marketStats = homes.reduce((acc, home) => {
      acc[home.markets] = acc[home.markets] ? acc[home.markets] + 1 : 1;
      return acc;
    }, {});

    // vehicleType estadisticas
    const vehicleTypeStats = homes.reduce((acc, home) => {
      acc[home.vehicleType] = acc[home.vehicleType] ? acc[home.vehicleType] + 1 : 1;
      return acc;
    }, {});

    // security estadisticas
    const securityStats = homes.reduce((acc, home) => {
      acc[home.security] = acc[home.security] ? acc[home.security] + 1 : 1;
      return acc;
    }, {});

    return {
      homeZones: homes.length,
      homeStats,
      marketZones: markets.length,
      marketStats,
      vehicleTypeStats,
      securityStats
    }
  });
  const getRouteNumber = () => {
    return parseInt(props.doc.index) + 1;
  }
</script>
<template>
  <div :class="{'detail': !props.list, 'border-blue-500': props.active}" >
    <h3 class="text-base sm:text-lg" v-if="!props.list">
      {{ props.full ? 'Ruta ' + getRouteNumber() + ' - ' : ''  }}
      {{ props.doc.name }}
    </h3>
    <div>
      <div class="flex flex-wrap mt-1 gap-2" v-if="!props.full">
        <div v-for="type in Object.keys(data.homeStats)" :key="type" class="p-1 houses">
            {{ labels.houses[type] }} [{{ data.homeStats[type] }}]
        </div>
        <div v-for="type in Object.keys(data.marketStats)" :key="type" class="p-1 houses">
            {{ labels.markets[type] }} [{{ data.marketStats[type] }}]
        </div>
      
        <div v-for="type in Object.keys(data.vehicleTypeStats)" :key="type" class="p-1 houses">
            {{ labels.vehicleType[type] }} [{{ data.vehicleTypeStats[type] }}]
        </div>
        <div v-for="type in Object.keys(data.securityStats)" :key="type" class="p-1 houses">
            {{ labels.security[type] }} [{{ data.securityStats[type] }}]
        </div>
      </div>
      <div v-if="props.full" class="flex text-xs gap-2 mt-2">
        <div>
          Vehiculos recomendados: {{ props.doc.vehicleQty }}  
        </div>
        <div>
          Personas por vehiculo: {{ props.doc.vehiclePeopleQty }}  
        </div>
      </div>
      <div v-if="props.list" class="flex flex-column text-xs gap-2 mt-2">
        <div v-if="data.homeZones > 0">
          Zonas pobladas: {{ data.homeZones }}
        </div>
        <div v-if="data.marketZones > 0">
          Zonas con negocios: {{ data.marketZones }}
        </div>
        <div>
          Vehiculos recomendados: {{ props.doc.vehicleQty }}  
        </div>
        <div>
          Personas por vehiculo: {{ props.doc.vehiclePeopleQty }}  
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped>
  h3 {
    font-weight: normal;
    margin: 5px 0 10px;
  }
  h4 {
    color: var(--label-secondary);
  }
  .houses {
    background-color: var(--fill-quaternary);
    border-radius: var(--radius-sm);
    font-size: .8rem;
  }
  .detail {
    padding: 10px 15px 15px;
    border: 1px solid var(--separator);
    border-radius: var(--radius-sm);
    margin: 10px 0 0;
    cursor: pointer;
  }
</style>